const initialState = {
  isModalVisible: false,
  title: '',
  path: ''
}

export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'modal/show':
      return {
        ...state,
        ...action.payload,
        isModalVisible: true
      };

    case 'modal/hide':
    return {
      ...state,
      isModalVisible: false
    };
  
    default:
      return state;
  }
}